export type EquipmentTypeCodeOption = {
  code: string
  name: string
}

export type LicensePlateStateOption = {
  code: string
  name: string
  country: 'CA' | 'MX' | 'US'
}

export const tractorEquipmentTypes: EquipmentTypeCodeOption[] = [
  { code: 'AR', name: 'Armored truck' },
  { code: 'AU', name: 'Automobile' },
  { code: 'BT', name: 'Box truck' },
  { code: 'BU', name: 'Bus' },
  { code: 'BV', name: 'Beverage truck' },
  { code: 'BY', name: 'Bicycle' },
  { code: 'CO', name: 'Construction vehicle (General)' },
  { code: 'EV', name: 'Emergency vehicle (General)' },
  { code: 'FE', name: 'Ferry' },
  { code: 'FM', name: 'Farm tractor' },
  { code: 'GB', name: 'Garbage truck' },
  { code: 'MC', name: 'Motorcycle' },
  { code: 'OC', name: 'Other' },
  { code: 'PM', name: 'Pick-up truck with camper' },
  { code: 'PN', name: 'Panel truck' },
  { code: 'PU', name: 'Pick-up truck' },
  { code: 'PV', name: 'Passenger, van' },
  { code: 'RV', name: 'Recreation vehicle' },
  { code: 'TR', name: 'Tractor (Semi)' },
  { code: 'TV', name: 'Van' },
]

export const trailerEquipmentTypes: EquipmentTypeCodeOption[] = [
  { code: '2B', name: '20 ft. Container (Closed top) sea container' },
  { code: '20', name: '20 ft. Container (Open top) sea container' },
  { code: '4B', name: '40 ft. Container (Closed top) sea container' },
  { code: '40', name: '40 ft. Container (Open top) sea container' },
  { code: 'TC', name: 'Auto carrier/trailer' },
  { code: 'BI', name: 'Beverage rack trailer' },
  { code: 'CH', name: 'Chassis' },
  { code: 'RT', name: 'Controlled temperature' },
  { code: 'TW', name: 'Controlled temperature trailer' },
  { code: 'DD', name: 'Double drop trailer' },
  { code: 'DT', name: 'Drop back trailer' },
  { code: 'RD', name: 'Fixed rack, Double drop trailer' },
  { code: 'RS', name: 'Fixed rack, Single drop trailer' },
  { code: 'FT', name: 'Flatbed/Perform trailer' },
  { code: 'FR', name: 'Flatbed trailer' },
  { code: 'FH', name: 'Flatbed trailer with headboards' },
  { code: 'FN', name: 'Flatbed trailer with no headboards' },
  { code: 'RG', name: 'Gondola (Closed)' },
  { code: 'RO', name: 'Gondola (Open)' },
  { code: 'CB', name: 'Gooseneck trailer' },
  { code: 'HC', name: 'Hopper car (Covered)' },
  { code: 'HP', name: 'Hopper car (Covered; Pneumatic discharge)' },
  { code: 'HO', name: 'Hopper car (Open)' },
  { code: 'HE', name: 'Horse trailer' },
  { code: 'LT', name: 'Livestock trailer' },
  { code: 'NC', name: 'No equipment' },
  { code: 'OE', name: 'Other' },
  { code: 'CL', name: 'Other length sea container (Closed top)' },
  { code: 'CU', name: 'Other length sea container (Open top)' },
  { code: 'CZ', name: 'Refrigerated container' },
  { code: 'TL', name: 'Semi truck trailer' },
  { code: 'SD', name: 'Single drop trailer' },
  { code: 'T8', name: 'Tank trailer (Chemicals) - Heated/Insulated' },
  { code: 'T6', name: 'Tank trailer (Chemicals) - Heated/Not insulated' },
  { code: 'T7', name: 'Tank trailer (Chemicals) - Not heated/Insulated' },
  { code: 'T5', name: 'Tank trailer (Chemicals) - Not heated/Not insulated' },
  { code: 'TK', name: 'Tank trailer (Food grade liquids)' },
  { code: 'T4', name: 'Tank trailer (Gas) - Heated/Insulated' },
  { code: 'T2', name: 'Tank trailer (Gas) - Heated/Not insulated' },
  { code: 'T3', name: 'Tank trailer (Gas) - Not heated/Insulated' },
  { code: 'T1', name: 'Tank trailer (Gas) - Not heated/Not insulated' },
  { code: 'L4', name: 'Tank trailer (Liquids) - Heated/Insulated' },
  { code: 'L2', name: 'Tank trailer (Liquids) - Heated/Not insulated' },
  { code: 'L3', name: 'Tank trailer (Liquids) - Not heated/Insulated' },
  { code: 'L1', name: 'Tank trailer (Liquids) - Not heated/Not insulated' },
  { code: 'TF', name: 'Trailer (Dry freight)' },
]

export const licensePlateStates: LicensePlateStateOption[] = [
  { code: 'AB', name: 'Alberta', country: 'CA' },
  { code: 'BC', name: 'British Columbia', country: 'CA' },
  { code: 'MB', name: 'Manitoba', country: 'CA' },
  { code: 'NB', name: 'New Brunswick', country: 'CA' },
  { code: 'NL', name: 'New Foundland and Labrador', country: 'CA' },
  { code: 'NT', name: 'Northwest Territories', country: 'CA' },
  { code: 'NS', name: 'Nova Scotia', country: 'CA' },
  { code: 'NU', name: 'Nunavut', country: 'CA' },
  { code: 'ON', name: 'Ontario', country: 'CA' },
  { code: 'PE', name: 'Prince Edward Island', country: 'CA' },
  { code: 'QC', name: 'Quebec', country: 'CA' },
  { code: 'SK', name: 'Saskatchewan', country: 'CA' },
  { code: 'YT', name: 'Yukon Territory', country: 'CA' },
  { code: 'AGU', name: 'Aguascalientes', country: 'MX' },
  { code: 'AL', name: 'Alabama', country: 'US' },
  { code: 'AK', name: 'Alaska', country: 'US' },
  { code: 'AS', name: 'American Samoa', country: 'US' },
  { code: 'AZ', name: 'Arizona', country: 'US' },
  { code: 'AR', name: 'Arkansas', country: 'US' },
  { code: 'AA', name: 'Armed Forces America', country: 'US' },
  { code: 'AE', name: 'Armed Forces Europe', country: 'US' },
  { code: 'AP', name: 'Armed Forces Pacific', country: 'US' },
  { code: 'BCN', name: 'Baja California Nord', country: 'MX' },
  { code: 'BCS', name: 'Baja California Sur', country: 'MX' },
  { code: 'CA', name: 'California', country: 'US' },
  { code: 'CAM', name: 'Campeche', country: 'MX' },
  { code: 'CHP', name: 'Chiapas', country: 'MX' },
  { code: 'CHH', name: 'Chihuahua', country: 'MX' },
  { code: 'COA', name: 'Coahuila', country: 'MX' },
  { code: 'COL', name: 'Colima', country: 'MX' },
  { code: 'CO', name: 'Colorado', country: 'US' },
  { code: 'CT', name: 'Connecticut', country: 'US' },
  { code: 'DE', name: 'Delaware', country: 'US' },
  { code: 'DC', name: 'District of Columbia', country: 'US' },
  { code: 'DIF', name: 'Distrito Federal', country: 'MX' },
  { code: 'DUR', name: 'Durango', country: 'MX' },
  { code: 'FL', name: 'Florida', country: 'US' },
  { code: 'GA', name: 'Georgia', country: 'US' },
  { code: 'GU', name: 'Guam', country: 'US' },
  { code: 'GUA', name: 'Guanajuato', country: 'MX' },
  { code: 'GRO', name: 'Guerrero', country: 'MX' },
  { code: 'HI', name: 'Hawaii', country: 'US' },
  { code: 'HID', name: 'Hidalgo', country: 'MX' },
  { code: 'ID', name: 'Idaho', country: 'US' },
  { code: 'IL', name: 'Illinois', country: 'US' },
  { code: 'IN', name: 'Indiana', country: 'US' },
  { code: 'IA', name: 'Iowa', country: 'US' },
  { code: 'JAL', name: 'Jalisco', country: 'MX' },
  { code: 'KS', name: 'Kansas', country: 'US' },
  { code: 'KY', name: 'Kentucky', country: 'US' },
  { code: 'LA', name: 'Louisiana', country: 'US' },
  { code: 'ME', name: 'Maine', country: 'US' },
  { code: 'MD', name: 'Maryland', country: 'US' },
  { code: 'MA', name: 'Massachusetts', country: 'US' },
  { code: 'MEX', name: 'Mexico State', country: 'MX' },
  { code: 'MI', name: 'Michigan', country: 'US' },
  { code: 'MIC', name: 'Michoacan', country: 'MX' },
  { code: 'MN', name: 'Minnesota', country: 'US' },
  { code: 'MS', name: 'Mississippi', country: 'US' },
  { code: 'MO', name: 'Missouri', country: 'US' },
  { code: 'MT', name: 'Montana', country: 'US' },
  { code: 'MOR', name: 'Morelos', country: 'MX' },
  { code: 'NAY', name: 'Nayarit', country: 'MX' },
  { code: 'NE', name: 'Nebraska', country: 'US' },
  { code: 'NV', name: 'Nevada', country: 'US' },
  { code: 'NH', name: 'New Hampshire', country: 'US' },
  { code: 'NJ', name: 'New Jersey', country: 'US' },
  { code: 'NM', name: 'New Mexico', country: 'US' },
  { code: 'NY', name: 'New York', country: 'US' },
  { code: 'NP', name: 'No Plate', country: 'US' },
  { code: 'NC', name: 'North Carolina', country: 'US' },
  { code: 'ND', name: 'North Dakota', country: 'US' },
  { code: 'MP', name: 'Northern Mariana Island', country: 'US' },
  { code: 'NLE', name: 'Nuevo Leon', country: 'MX' },
  { code: 'OAX', name: 'Oaxaca', country: 'MX' },
  { code: 'OH', name: 'Ohio', country: 'US' },
  { code: 'OK', name: 'Oklahoma', country: 'US' },
  { code: 'OR', name: 'Oregon', country: 'US' },
  { code: 'PA', name: 'Pennsylvania', country: 'US' },
  { code: 'PUE', name: 'Puebla', country: 'MX' },
  { code: 'PR', name: 'Puerto Rico', country: 'US' },
  { code: 'QUE', name: 'Queretaro', country: 'MX' },
  { code: 'ROO', name: 'Quintana Roo', country: 'MX' },
  { code: 'RI', name: 'Rhode Island', country: 'US' },
  { code: 'SLP', name: 'San Luis Potosi', country: 'MX' },
  { code: 'SIN', name: 'Sinaloa', country: 'MX' },
  { code: 'SON', name: 'Sonora', country: 'MX' },
  { code: 'SC', name: 'South Carolina', country: 'US' },
  { code: 'SD', name: 'South Dakota', country: 'US' },
  { code: 'TAB', name: 'Tabasco', country: 'MX' },
  { code: 'TAM', name: 'Tamaulipas', country: 'MX' },
  { code: 'TN', name: 'Tennessee', country: 'US' },
  { code: 'TX', name: 'Texas', country: 'US' },
  { code: 'TLA', name: 'Tlaxcala', country: 'MX' },
  { code: 'UT', name: 'Utah', country: 'US' },
  { code: 'VER', name: 'Vera Cruz', country: 'MX' },
  { code: 'VT', name: 'Vermont', country: 'US' },
  { code: 'VA', name: 'Virginia', country: 'US' },
  { code: 'VI', name: 'Virgin Islands', country: 'US' },
  { code: 'WA', name: 'Washington', country: 'US' },
  { code: 'WV', name: 'West Virginia', country: 'US' },
  { code: 'WI', name: 'Wisconsin', country: 'US' },
  { code: 'WY', name: 'Wyoming', country: 'US' },
  { code: 'YUC', name: 'Yucatan', country: 'MX' },
  { code: 'ZAC', name: 'Zacatecas', country: 'MX' },
]
